import React from 'react';

import { Flex } from 'antd';
import { ColumnType } from 'antd/es/table';

import styles from './VerticalTableBody.module.scss';

import { TVerticalTableProps } from '../../VerticalTable.types';

export const VerticalTableBody = <T,>({
	columns,
	dataSource,
	rowKey,
	onColumn,
}: TVerticalTableProps<T>): React.JSX.Element => {
	const getRowKey = (record: T, idx: number): string =>
		typeof rowKey === 'function'
			? rowKey(record)
			: (record[rowKey as keyof T] as string) ?? String(idx);

	const handleColumnClick = (record: T, columnIndex: number, column: ColumnType<T>): void => {
		onColumn?.onClick?.(record, columnIndex, column);
	};

	return (
		<Flex className={styles['container']} vertical>
			{columns?.map((col, colIdx) => (
				<Flex key={col.key || col?.dataIndex?.toString() || colIdx} className={styles['row']}>
					<Flex align="center" className={styles['header-cell']} justify="center">
						{typeof col.title === 'function' ? null : col.title}
					</Flex>
					{dataSource.map((record, rowIdx) => (
						<div
							key={getRowKey(record, rowIdx)}
							className={styles['cell']}
							data-column-index={rowIdx}
							onClick={() => handleColumnClick(record, rowIdx, col)}
						>
							{col.render
								? (col.render(record[col.dataIndex as keyof T], record, rowIdx) as React.ReactNode)
								: String(record[col.dataIndex as keyof T] ?? '')}
						</div>
					))}
				</Flex>
			))}
		</Flex>
	);
};
